const valueFilter = val => {
	// Properly check if value is null
	// Prevent case when value is `false` and it would return falsy
	// Prevent case when value is `0` and it would return falsy
	if (val !== null && val !== undefined && val !== "") return val
	return "N/A"
}

const extractFromScalarValueFilter = scalarValue => {
	if (!scalarValue) return null
	const { stringValue, numberValue, dateValue, booleanValue } = scalarValue
	if (stringValue) return stringValue
	if (numberValue !== null && numberValue !== undefined)
		// NOTE: this is probably not a proper approach as we should define how numbers should be formatted
		// Perhaps definition like tjis should be in tenant settings
		// For now, we just format it as so 1,000,000.00 so that it is more readable
		return numberValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
	if (booleanValue !== null && booleanValue !== undefined) return booleanValue
	if (dateValue) return dateValue
	return null
}

export { valueFilter, extractFromScalarValueFilter }
